export const ITEM_COLOR = [
  {
    main: '#007AFF',
    sub: '#E6F6FF',
  },
  {
    main: '#5CDBD3',
    sub: '#E6FFFB',
  },
  {
    main: '#34C759',
    sub: '#F0FFF1',
  },
  {
    main: '#A0D911',
    sub: '#FCFFE6',
  },
  {
    main: '#FFAD29',
    sub: '#FFF9E6',
  },
  {
    main: '#FFCC00',
    sub: '#FFFEE6',
  },
  {
    main: '#FF99AA',
    sub: '#FFF2F4',
  },
  {
    main: '#F759AB',
    sub: '#FFF0F6',
  },
  {
    main: '#9254DE',
    sub: '#F9F0FF',
  },
  {
    main: '#504DFF',
    sub: '#F0F0FF',
  },
];

export const mainColor = ITEM_COLOR.map((ele) => {
  return ele.main;
});
